import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import InfoWindowItem from "./InfoWindowItem";

const MarkerTooltip = () => {
    const {isShowMarkerTooltip} = useSelector((state:RootState)=>state.mapList)
    return ( <>
    {
        isShowMarkerTooltip&&
        <>
    <InfoWindowItem/>
        </>
    }
    
    </> );
}
 
export default MarkerTooltip;